module.exports = __webpack_public_path__ + "img/edit-icon.c0a4ebe9.svg";